import gql from 'graphql-tag';

export const STAGE_FIELD_SCHEMA_FRAGMENT = gql`
  fragment StageFieldSchemaFragment on StageFieldSchema {
    id
    name
    fieldSchemas {
      id
      name
      __typename
    }
    __typename
  }
`;

export const GET_STAGE_FIELD_SCHEMAS_QUERY = gql`
  query StageFieldSchemasQuery($programId: Int!, $stageId: Int) {
    getStageFieldSchemas(programId: $programId, stageId: $stageId) {
      ...StageFieldSchemaFragment
      __typename
    }
  }
  ${STAGE_FIELD_SCHEMA_FRAGMENT}
`;
